import { Button, Grid, Typography, useMediaQuery, useTheme } from '@material-ui/core';

import React, { FC, useState } from 'react';
import { useStyles } from './styles';
import Documents from '@public/pages/Documents';
import project, { isSpecialBilling, isUsinsk } from '@constants/project';
import { documents } from '@public/Root';
import { MINIO_END_POINT } from '@core/constants/minio';

type Props = {
  setPolicyModalAgreement: (policyModalAgreement: string | null) => void;
};

const PolicyModalAgreement: FC<Props> = ({ setPolicyModalAgreement }) => {
  const classes = useStyles();
  const theme = useTheme();

  const isXs = useMediaQuery(theme.breakpoints.down('xs'));

  const [openPrivacyPolicy, setOpenPrivacyPolicy] = useState(false);

  const handleUpdateLocalStoragePolicyModalAgreement = () => {
    localStorage.setItem('PolicyModalAgreement', 'agreement');
    setPolicyModalAgreement('agreement');
  };

  return (
    <>
      <Grid
        style={{
          backgroundColor: '#07003D',
          padding: isXs ? '10px' : '25px 53px',
          borderRadius: 8,
          width: isXs ? '90%' : '80%',
          margin: isXs ? '20px auto' : '0 auto',
          position: 'fixed',
          bottom: '20px',
          display: 'flex',
          flexDirection: isXs ? 'column' : 'row',
          justifyItems: 'center',
          justifyContent: 'center',
          alignItems: 'center',
          gap: isXs ? 10 : 20,
          maxWidth: '1300px',
          minHeight: '126px',
          height: 'max-content',
          boxSizing: 'border-box',
          zIndex: 1300,
          marginTop: '20px',
          left: 0,
          right: 0,
        }}
      >
        <Typography
          style={{
            color: 'white',
            fontSize: isXs ? 15 : 18,
            lineHeight: isXs ? '17px' : '20px',
            fontWeight: 400,
            textAlign: isXs ? 'center' : 'left',
          }}
        >
          Мы используем cookie-файлы и сервис Яндекс Метрика для повышения качества работы сайта,
          сбора статистических данных и улучшения наших сервисов, продуктов и услуг. Подробнее в{' '}
          <span className={classes.userLicenseLink} onClick={() => setOpenPrivacyPolicy(true)}>
            Политике обработки и обеспечения безопасности персональных данных
          </span>
        </Typography>
        <Button
          style={{
            padding: '5px 10px',
            width: isXs ? '130px' : '170px',
            minWidth: isXs ? '130px' : '170px',
            height: isXs ? '35px' : '40px',
            fontSize: isXs ? 15 : 18,
          }}
          variant="contained"
          color="primary"
          onClick={handleUpdateLocalStoragePolicyModalAgreement}
        >
          Принять
        </Button>
      </Grid>
      <Documents
        open={openPrivacyPolicy}
        setOpen={setOpenPrivacyPolicy}
        title={documents[1].title}
        uri={`${MINIO_END_POINT}/${
          isSpecialBilling ? 'billing' : project
        }/notsecured/00000000-0000-0000-0000-000000000000/${documents[1].uri}`}
      />
    </>
  );
};

export default PolicyModalAgreement;
